<eqa-top-panel></eqa-top-panel>
<eqa-sidenav [context]="navContext$ | async"></eqa-sidenav>
<eqa-content>
	<router-outlet></router-outlet>
</eqa-content>
